// QA2 testing environment (values copied from environment.qa.ts)
// Secrets are injected via CI/CD pipeline

export const environment = {
  production: false,
  messages: {
    console: true,
    alert: true,
    confirm: false,
    notify: false,
    error: false,
    track: false,
    debug_messages: false,
    debug: true,
  },
  api: {
    url: 'https://qa2.hotelcard.com/api',
    mock: false,
    enableMocks: false,
    hotel_images: 'https://hotelcard-stage.fra1.digitaloceanspaces.com/',
    customer_redirect_to: 'https://qa2.hotelcard.com',
    oauth: {
      grant_type: 'password',
      client_id: '14',
      client_secret: 'db0f5c4074f71795979f71138ca69b0a82cecdbb52594c3a66b159c5a60afc71',
    },
  },
  // Google Maps API key - injected at build time
  googleMapsApiKey: '__GOOGLE_MAPS_API_KEY__',
  translations: {
    whitelist: ['en', 'de', 'it', 'fr'],
    fallbackLng: 'de',
    debug: true,
    returnEmptyString: false,
    ns: ['translations', 'errors', 'titles'],
    initImmediate: false,
    backend: {
      loadPath: function () {
        return 'assets/i18n/{{ns}}/{{lng}}.json?date=' + new Date().getTime();
      }
    },
    detection: {
      order: ['querystring', 'cookie', 'navigator', 'hotelCardLangDetector'],
      lookupCookie: 'lang',
      caches: ['cookie'],
      cookieMinutes: 10080, // 7 days
      lookupQuerystring: 'locale',
    },
    keySeparator: '.',
    fallbackNS: 'translations',
  },
};
